module.exports = __webpack_public_path__ + "opsgenie-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/opsgenie-logo.png
// module id = 1261
// module chunks = 74